import React, { Component } from "react";
import Button from "react-md/lib/Buttons";
import Card from "react-md/lib/Cards/Card";
import CardText from "react-md/lib/Cards/CardText";
import Helmet from "react-helmet";
import Layout from "../layout";
import config from "../../data/SiteConfig";

const styles = {
  p5js: {
    width: "400px",
    height: "250px"
  }
};
class Reservplace extends Component {
  render() {
    return (
      <Layout location={this.props.location} title='예약하기'>
        <div>
          <Helmet>
            <title>{`reserv | ${config.siteTitle}`}</title>
            <link rel='canonical' href={`${config.siteUrl}/reserv/`} />
          </Helmet>
          <div>
            <Card align='left'>
              <CardText>
                <p> * 모델링 파일 확인 </p>

                <img
                  src={`${config.siteUrl}/assets/car_model_img_file10.png`}
                  alt='drive'
                />

                <p>{`   `}</p>

                <p> * 장소 선택 </p>
                <div>선택한 장소 : 이모티콘 메이커 스페이스</div>

                <p className='md-title-1'> * 시간 선택 </p>

                <iframe
                  style={styles.p5js}
                  src='https://editor.p5js.org/Flik/embed/CF_wg7-JX'
                />

                <Button
                  className='user-button'
                  secondary
                  flat
                  key='about'
                  iconClassName='fa fa-check-circle'
                  href={`${config.siteUrl}/reservsuccess`}
                >
                  예약신청
                </Button>
              </CardText>
            </Card>
          </div>
        </div>
      </Layout>
    );
  }
}

export default Reservplace;
